import { Controller } from "@hotwired/stimulus"

// Landing partner — Sección 3: calculadora de ahorro.
// Dos variables independientes:
//   · VENTAS  (slider) → comisión apps delivery = ventas × appsRate
//   · ÓRDENES (slider) → plan Greatfood (tramos por órdenes/mes) → precio del plan
// Ahorro = comisión apps − precio del plan.
// Los tramos (con precio) llegan como JSON desde la vista (data-...-tiers-value);
// Los defaults espejan Partners::PlansHelper (la vista manda los reales). appsRate también es editable.
export default class extends Controller {
  static targets = [
    "sales", "salesLabel",
    "orders", "ordersLabel",
    "appsCost", "planName", "gfCost", "savings"
  ]
  static values = {
    appsRate: { type: Number, default: 0.25 },
    tiers: {
      type: Array,
      default: [
        { name: "Free",  maxOrders: 200,  price: 0 },
        { name: "Base",  maxOrders: 1000, price: 39990 },
        { name: "Medio", maxOrders: 2000, price: 79990 },
        { name: "A tu medida", maxOrders: null, price: null }
      ]
    }
  }

  connect() { this.update() }

  update() {
    const sales = Number(this.salesTarget.value)
    const orders = Number(this.ordersTarget.value)

    // Ventas → comisión de las apps de delivery
    const appsCost = Math.round(sales * this.appsRateValue)

    // Órdenes → plan Greatfood que aplica + su precio
    const tier = this.tierForOrders(orders)
    // price null = plan a tu medida (Pro, venta asistida): no se cotiza acá.
    const custom = tier.price === null || tier.price === undefined
    const gfCost = custom ? 0 : tier.price
    const savings = Math.max(0, appsCost - gfCost)

    if (this.hasSalesLabelTarget) this.salesLabelTarget.textContent = this.clp(sales)
    if (this.hasOrdersLabelTarget) this.ordersLabelTarget.textContent = `${this.int(orders)} órdenes`
    if (this.hasAppsCostTarget) this.appsCostTarget.textContent = this.clp(appsCost)
    if (this.hasPlanNameTarget) this.planNameTarget.textContent = tier.name
    if (this.hasGfCostTarget) this.gfCostTarget.textContent = custom ? "A cotizar" : this.clp(gfCost)
    if (this.hasSavingsTarget) this.savingsTarget.textContent = custom ? "—" : this.clp(savings)
  }

  // Primer tramo cuyo tope de órdenes alcanza; maxOrders null = sin tope (a tu medida).
  tierForOrders(orders) {
    const tiers = this.tiersValue
    for (const t of tiers) {
      if (t.maxOrders === null || orders <= t.maxOrders) return t
    }
    return tiers[tiers.length - 1]
  }

  clp(value) {
    return new Intl.NumberFormat("es-CL", {
      style: "currency",
      currency: "CLP",
      maximumFractionDigits: 0
    }).format(value || 0)
  }

  int(value) {
    return new Intl.NumberFormat("es-CL").format(value || 0)
  }
}
